export { AnimatedText } from './AnimatedText';
export type { AnimatedTextProps, AnimatedTextVariant } from './AnimatedText';
